<template>
  <div class="page">
    <h2>Partner</h2>
    <PartnerDetails :partner="partner"/>

    <pre class="debug" v-show="debugMode">{{ partner }}</pre>

  </div>
</template>

<script>
import { mapState } from 'vuex'
import PartnerDetails from '@/components/PartnerDetails.vue'

export default {
  name: 'partner',
  components: {
    PartnerDetails
  },
  computed: {
    ...mapState([
      'debugMode',
      'partner'
    ])
  }
}
</script>
